module.exports = __webpack_public_path__ + "static/media/page.9a2d980f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/Seers/page.jpg
// module id = 143
// module chunks = 0